var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"id":"PREV","name":"PREV","data-vcode":"PREV"}},[_c('img',{attrs:{"src":"/images/icons/last.svg","alt":"","role":"img","aria-hidden":"true"}}),_c('label',[_vm._v(_vm._s(_vm.$t('prevButton')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }